import { Injectable } from '@angular/core';
import { Http, Request, RequestOptions, RequestOptionsArgs, Response, Headers } from '@angular/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class HttpService extends Http {
  
  constructor(backend: any, defaultOptions: RequestOptions) {
    super(backend, defaultOptions);
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    const apiKey = environment.API_KEY; 
    const encryptionSecret = CryptoJS.enc.Hex.parse(environment.ENCRYPTION_SECRET); // 32-byte key
    const encrypted = CryptoJS.AES.encrypt(apiKey, encryptionSecret, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    let encryptedText = encrypted.toString();  
    const token = encryptedText.replace(/\//g, '_').replace(/\+/g, '-');
    if (typeof url === 'string') {
      options = options || new RequestOptions();
      options.headers = options.headers || new Headers();
      options.headers.append('Authorization', `Bearer ${token}`);
    } else {
      // If the request is a full Request object, modify its headers
      url.headers = url.headers || new Headers();
      url.headers.append('Authorization', `Bearer ${token}`);
    }
    return super.request(url, options);
  }
}



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/services/http.service.ts